var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5502 2.50465L10.4952 0.449649C10.227 0.197721 9.87556 0.0531684 9.50772 0.0434883C9.13988 0.0338082 8.78131 0.159676 8.50022 0.397149L1.75022 7.14715C1.5078 7.39162 1.35685 7.71205 1.32272 8.05465L1.00022 11.1821C0.990119 11.292 1.00437 11.4027 1.04197 11.5064C1.07956 11.6101 1.13957 11.7043 1.21772 11.7821C1.2878 11.8517 1.37091 11.9067 1.46229 11.944C1.55367 11.9813 1.65152 12.0002 1.75022 11.9996H1.81772L4.94522 11.7147C5.28782 11.6805 5.60825 11.5296 5.85272 11.2871L12.6027 4.53715C12.8647 4.26037 13.0063 3.89103 12.9965 3.51005C12.9866 3.12907 12.8261 2.76753 12.5502 2.50465ZM4.81022 10.2147L2.56022 10.4246L2.76272 8.17465L7.00022 3.98965L9.02522 6.01465L4.81022 10.2147ZM10.0002 5.00965L7.99022 2.99965L9.45272 1.49965L11.5002 3.54715L10.0002 5.00965Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cd504280e4b308bae9c1156bfbe79b27.svg";
export { ForwardRef as ReactComponent };